import actionCreatorFactory from "typescript-fsa";
import { actions } from "./reducer";

const create = actionCreatorFactory("requestProgress");

export const resetRequestProgress = create<actions>("RESET_REQUEST_PROGESS");



// WEBPACK FOOTER //
// ./src/requestProgress/actions.ts